import React, { FC, HTMLAttributes, ReactNode, useId } from 'react';
import { OverlayTrigger } from '../../ui/overlay-trigger/overlay-trigger';
import Tooltip from '../../ui/tooltip';
import classNames from '../../utils/classnames';
import './checkbox.scss';

type CheckboxProps = HTMLAttributes<HTMLInputElement> & {
    className: string;
    title: React.JSX.Element | Element | string | ReactNode;
    type: string;
    id?: number | string;
    checked?: boolean;
    checkedBgColor?: 'green' | 'dark';
    disabled?: boolean;
    labelClassName?: string;
    name?: string;
    showTooltip?: boolean;
    tooltip?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox: FC<CheckboxProps> = (props) => {
    const {
        className = '',
        checkedBgColor = 'green',
        labelClassName = '',
        showTooltip = false,
        title,
        tooltip = '',
        type = 'checkbox',
        ...propsRest
    } = props;

    const uniqId = useId();

    propsRest.id = propsRest.id ?? uniqId;

    const label = (
        <label className={classNames('lmp-checkbox-label', labelClassName, checkedBgColor)} htmlFor={propsRest.id}>
            {title}
        </label>
    );

    return (
        <div className={classNames('lmp-checkbox', className, { disabled: propsRest.disabled })}>
            <input type={type} {...propsRest} />
            {showTooltip && tooltip ? (
                <OverlayTrigger
                    placement='top-start'
                    overlay={<Tooltip.Simple id={`checkbox-tooltip-${propsRest.id}`}>{tooltip}</Tooltip.Simple>}
                >
                    {label}
                </OverlayTrigger>
            ) : (
                label
            )}
        </div>
    );
};

export default Checkbox;
